import { docType } from './constants';

export const deleteDocModal = async (type: docType): Promise<boolean> => {
  return window.confirm(`Are you sure you want to delete this ${type}? This action is not reversible`);
};

/** Deleting a project: the server sends its files to Admin › Deleted items (bin.ts, 5 Nov 2026). */
export const deleteProjectModal = async (): Promise<boolean> =>
  window.confirm(
    "Delete this project?\n\nIts records and notes are deleted. Its files move to Admin › Deleted items, where an admin can restore them for 30 days. After that they're deleted for good.",
  );

export const deleteModal = async (message: string): Promise<boolean> => {
  return window.confirm(message);
};
